<template>
  <layout-panel>
    <template slot="header">操作日志</template>
    <template slot="tools">
      <el-button type="primary"
                 size="small"
                 icon="el-icon-refresh"
                 @click="onRefresh()"></el-button>
    </template>
    <el-table :data="table"
              stripe
              highlight-current-row
              border>
      <template v-for="attr of logColumns">
        <el-table-column v-bind="attr"></el-table-column>
      </template>
      <el-table-column fixed="right"
                       label="操作"
                       width="120">
        <template slot-scope="scope">
          <div>
            <el-button type="text"
                       size="small"
                       v-if="hasSuperPermission()"
                       @click="showDataDiff(scope.row)">查看数据变化
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination background
                     @size-change="handleSizePageChange"
                     @current-change="handleCurrentPageChange"
                     :current-page="pagination.current_page"
                     :page-sizes="[20, 50, 100, 200]"
                     :page-size="pagination.per_page"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="pagination.total">
      </el-pagination>
    </div>

    <el-dialog title="数据变化"
               :visible.sync="dataDiffDialogVisible"
               width="900px"
               top="5vh">
      <div class="data-diff-container"
           v-if="currentLogData">
        <el-table :data="getDiffData()"
                  border
                  :show-header="true">
          <el-table-column prop="field"
                           label="字段"
                           width="180">
            <template slot-scope="scope">
              <span class="field-name">{{ scope.row.fieldLabel }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="oldValue"
                           label="旧值"
                           class-name="diff-value-cell">
            <template slot-scope="scope">
              <div v-if="Array.isArray(scope.row.oldValue) && scope.row.oldValue.length > 0"
                   class="log-tag-container">
                <el-tag v-for="(item, index) in scope.row.oldValue"
                        :key="index"
                        size="mini"
                        class="value-tag"
                        :title="item"
                        @click="copyToClipboard(item)">
                  {{ index + 1 }}. {{ item }}
                </el-tag>
              </div>
              <div v-else
                   class="value-content old-value"
                   :title="scope.row.oldValue">
                {{ scope.row.oldValue }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="newValue"
                           label="新值"
                           class-name="diff-value-cell">
            <template slot-scope="scope">
              <div v-if="Array.isArray(scope.row.newValue) && scope.row.newValue.length > 0"
                   class="log-tag-container">
                <el-tag v-for="(item, index) in scope.row.newValue"
                        :key="index"
                        size="mini"
                        type="success"
                        class="value-tag"
                        :title="item"
                        @click="copyToClipboard(item)">
                  {{ index + 1 }}. {{ item }}
                </el-tag>
              </div>
              <div v-else
                   class="value-content new-value"
                   :title="scope.row.newValue">
                {{ scope.row.newValue }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </layout-panel>
</template>

<script>
import table from '@core/mixins/table-v3'

export default {
  components: {},
  mixins: [table],
  props: {
    internUserId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      search: {
        id: null,
        intern_user_id: null,
      },
      logColumns: [
        {prop: 'id', label: '操作ID', width: '120'},
        {prop: 'action', label: '操作', minWidth: '150'},
        {prop: 'creator', label: '操作人', width: '150'},
        {prop: 'created_at', label: '操作时间', width: '180'},
      ],
      dataDiffDialogVisible: false,
      currentLogData: null,
      fieldLabels: {
        'id': '用户ID',
        'name': '账号',
        'realname': '姓名',
        'employment_type': '人员性质',
        'status': '状态',
        'phone': '手机号',
        'mail_address': '个人邮箱',
        'school': '目前所在院校',
        'major': '专业',
        'education_level': '学历',
        'grade_level': '当前学年段',
        'student_card_photos': '学生证照片',
        'contract_start_date': '合同开始时间',
        'contract_end_date': '合同结束时间',
        'remark': '备注',
        'assigned_customers': '客户资源',
        'ui_roles': 'UI权限角色',
        'api_roles': 'API权限角色',
        'created_at': '创建时间',
        'id_number': '身份证号码',
        'id_card_front_photo': '身份证正面照片',
        'id_card_back_photo': '身份证反面照片',
        'bank_name': '银行名称',
        'bank_branch_name': '支行名称',
        'bank_card_number': '银行卡号',
        'bank_card_photo': '银行卡照片',
      }
    }
  },
  computed: {
    ...Vuex.mapState({}),
  },
  created () {},
  mounted () {},
  watch: {
    internUserId (newVal) {
      if (newVal) {
        this.search.intern_user_id = newVal
        this.loadTableData({})
      }
    }
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    getTableData (params) {
      return request.common('queryInternLogTableApi', params)
    },
    showDataDiff (logItem) {
      if (!this.hasSuperPermission()) {
        this.$message.error('您并非超级管理员,无法查看数据变化')
        this.dataDiffDialogVisible = false
        return
      }
      this.currentLogData = logItem.data
      this.dataDiffDialogVisible = true
    },
    hasSuperPermission () {
      return filter.superPermission()
    },
    /**
     * 格式化值用于显示（数组返回数组，其他返回字符串）
     */
    formatValueForDisplay (value, field) {
      if (value === null || value === undefined) {
        return '-'
      }
      if (Array.isArray(value)) {
        return value
      }
      if (typeof value === 'object') {
        return JSON.stringify(value, null, 2)
      }
      if (['id_card_front_photo', 'id_card_back_photo'].includes(field) && !Array.isArray(value)) {
        return [value]
      }
      return String(value)
    },
    /**
     * 复制文本到剪贴板
     * @param {String} text - 要复制的文本
     */
    copyToClipboard (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('已复制到剪贴板')
    },
    /**
     * 获取变化数据用于表格显示
     * @returns {Array} 格式化后的变化数据数组
     */
    getDiffData () {
      if (!this.currentLogData || !this.currentLogData.new) {
        return []
      }
      // 以下字段的变化不显示到页面上
      const excludedFields = [
        'participant_customers', 'participant_projects', 'account_id',
        'updated_at', 'total_work_days', 'intern_user_id'
      ]
      const diffData = []
      Object.keys(this.currentLogData.new).forEach(key => {
        if (!excludedFields.includes(key)) {
          diffData.push({
            field: key,
            fieldLabel: _.get(this.fieldLabels, key, key),
            oldValue: this.formatValueForDisplay(this.currentLogData.old[key], key),
            newValue: this.formatValueForDisplay(this.currentLogData.new[key], key)
          })
        }
      })
      return diffData
    }
  },
}
</script>
<style lang="scss">
.data-diff-container {
  max-height: 70vh;
  overflow-y: auto;
}

.field-name {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
}

.diff-value-cell {
  padding: 4px 0 !important;
}

.log-tag-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px;
  box-sizing: border-box;
  text-align: left;
  align-items: flex-start;
}

.value-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
  margin: 0;
}

.value-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.value-content {
  font-size: 12px;
  line-height: 1.5;
  padding: 6px 4px;
  border-radius: 3px;
  border: 1px solid #dcdfe6;
  word-break: break-all;
  white-space: normal;
  font-family: 'Courier New', monospace;
  max-height: 120px;
  min-height: 30px;
  overflow-y: auto;
  text-align: left;
}

.value-content.old-value {
  background-color: #fef0f0;
  border-color: #fbc4c4;
}

.value-content.new-value {
  background-color: #f0f9ff;
  border-color: #b3d8ff;
}

.no-changes {
  text-align: right;
  padding: 40px;
  color: #909399;
  font-size: 14px;
}

.el-form-item__tips {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 5px;
}
</style>
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/components/InternLogTable.vue